import { render } from "./TestCasesValidationsTable.vue?vue&type=template&id=5e88a4cb&scoped=true"
import script from "./TestCasesValidationsTable.vue?vue&type=script&lang=js"
export * from "./TestCasesValidationsTable.vue?vue&type=script&lang=js"

import "./TestCasesValidationsTable.vue?vue&type=style&index=0&id=5e88a4cb&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e88a4cb"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
